import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.function.name.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { call, get, sync } from 'vuex-pathify';
import FingerprintJS from '@fingerprintjs/fingerprintjs'; // import cloneDeep from 'lodash/cloneDeep'; //! only in use on function which doesn't do anything
// import merge from 'lodash/merge'; //! only in use on function which doesn't do anything

import moment from 'moment';
import parser from 'cron-parser';
import setupClass from '@/boot/setup';
import { FIB } from '@/config/constants';
import { surveyLeft, enableAnalytics, surveyStarted } from "./boot/google-analytics";
var POLLING_FREQUENCY = FIB.POLLING_FREQUENCY; // Use Polling Frequency and Download Update States constants

export default {
  name: 'App',
  components: {
    FibCookieConsentModal: require('@/components/FIBCookieConsentModal').default
  },
  data: function data() {
    return {
      baseFontFamily: [],
      pollInProgress: false,
      setup: null
    };
  },
  computed: _objectSpread(_objectSpread({}, sync('settings', ['hasConnectivity', 'updateWhenOnline'])), {}, {
    baseStyles: function baseStyles() {
      return {
        fontFamily: this.$store.getters['theme/theme'].fontFamily
      };
    },
    branchId: get('config/branchId'),
    layout: function layout() {
      // Dynamically load and return the route's layout or the default layout
      // const layout = 'Layout' // Development layout with header and drawer components
      var layout = this.$route.meta.layout || 'Default'; // Use route layouts

      return require("@/layouts/".concat(layout)).default;
    },
    nextSync: sync('config/nextSync'),
    setupComplete: get('settings/setupComplete'),
    surveyInProgress: get('surveys/surveyInProgress'),
    currentSurvey: get('surveys/currentSurvey'),
    syncSchedule: get('config/syncSchedule'),
    uuid: sync('config/uuid'),
    urlParams: get('checkIn/urlParams'),
    refreshing: get('app/GET_APP_REFRESHING'),
    registered: get('config/registered'),
    isApp: get('config/isApp'),
    isLoading: get('app/GET_PAGE_LOADING'),
    requestingCookieConsent: get('cookies/GET_REQUESTING_CONSENT'),
    cookieConsent: get('cookies/GET_CONSENTED'),
    loadingType: get('app/GET_PAGE_LOADING_TYPE'),
    companyDetails: get('config/getCompanyDetails'),
    submittedData: function submittedData() {
      var submitted = this.$store.getters['responses/submitted'] || {};
      return !!submitted.id;
    }
  }),
  watch: {
    $route: function $route(to) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _to$query;

        var title, urlParamsSlug, fetchedConfigSlug, querySlug, safeRoutes, pathIsSafeRoute, slugFromPath, _to$query2, _params;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(to.path === '/')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                /**
                 * Configure page title using meta data or the fallback if no meta data is available.
                 *
                 * Meta title data should be an i18n key in the `i18n/ISO_LANGUAGE_CODE/route.js` file.
                 *
                 * The reason we're watching for a route change and assigning the title here rather than in
                 * `router/index.js` is so we're able to pick up the correct meta data following a redirect.
                 */
                title = _this.$t(to.meta.title);
                document.title = title ? _this.$tc('route.template', title) : _this.$t('route.fallback'); // Prevent any further processing based on route if we're 404ing.

                if (!(to.path === '/error-404')) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                urlParamsSlug = (_this.urlParams || {}).slug;
                fetchedConfigSlug = _this.$store.getters['checkIn/fetchedSlug'];
                querySlug = to === null || to === void 0 ? void 0 : (_to$query = to.query) === null || _to$query === void 0 ? void 0 : _to$query.slug;
                safeRoutes = ['thank-you', 'checkout', 'share', 'recommend', 'questions', 'register', 'manage_team', 'staff', 'check_in', 'upload', 'error-404']; // Check to see if the route matches any of the safe routes.

                pathIsSafeRoute = safeRoutes.filter(function (safeRoute) {
                  return ((to.path || '').split('/')[1] || '').toLowerCase() === (safeRoute || '').toLowerCase();
                }).length !== 0; // Wont have fetchedConfigSlug on first load as we need to do the setup.
                // On redirect to the start of the checkin process we need to check to see if there is a fetchedConfigSlug
                // If there is a fetchedConfigSlug then we check to see if its the set querySlug or the urlParamsSlug
                // If it is neither of the two then we need to run through the initial setup with the passed in slug
                // If there is neither of them then we don't need to do anything.
                // If there is no fetchedConfigSlug then we need to run the setup
                // If the route does not include check_in then we need to check to see if a new slug has been passed

                if (!(!fetchedConfigSlug && !((to === null || to === void 0 ? void 0 : to.path) || '').includes('register') || !pathIsSafeRoute)) {
                  _context.next = 17;
                  break;
                }

                if (!pathIsSafeRoute) {
                  _params = to.path.match(/^\/([a-zA-Z0-9-]+)\/?(.*)\/?$/);

                  if (_params) {
                    slugFromPath = {
                      slug: _params[1]
                    };
                  }

                  if (to !== null && to !== void 0 && (_to$query2 = to.query) !== null && _to$query2 !== void 0 && _to$query2.slug) {
                    slugFromPath = to.query.slug;
                  }

                  _this.$store.commit('checkIn/setParams', slugFromPath);
                }

                if (!(slugFromPath || !fetchedConfigSlug || _this.isApp)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 16;
                return _this.setup.initialSetup(_this.$store, _this.$router, _this.$q, _this.$route);

              case 16:
                return _context.abrupt("return");

              case 17:
                if (!(to.path || '').includes('check_in')) {
                  _context.next = 29;
                  break;
                }

                if (querySlug) {
                  _context.next = 21;
                  break;
                }

                _this.$router.replace({
                  path: to === null || to === void 0 ? void 0 : to.path,
                  query: {
                    slug: urlParamsSlug || fetchedConfigSlug
                  }
                }); // return here as on the route change it will come in again so we can check the query params


                return _context.abrupt("return");

              case 21:
                if (!_this.submittedData) {
                  _context.next = 25;
                  break;
                }

                _context.next = 24;
                return _this.setup.initialSetup(_this.$store, _this.$router, _this.$q, _this.$route);

              case 24:
                return _context.abrupt("return");

              case 25:
                if (!(fetchedConfigSlug !== querySlug)) {
                  _context.next = 29;
                  break;
                }

                // Update the store to set the new url param to be the querySlug so we can get this config
                _this.$store.commit('checkIn/setParams', {
                  slug: querySlug
                }); // Lets go and do the setup


                _context.next = 29;
                return _this.setup.initialSetup(_this.$store, _this.$router, _this.$q, _this.$route);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    hasConnectivity: function hasConnectivity(newState) {
      if (newState) {
        Logger.debug('Connectivity is online'); // Poll the server when we come back online if `updateWhenOnline` flag is set

        if (this.updateWhenOnline) {
          this.updateWhenOnline = false;
          this.$root.$emit('poll-server');
        }
      } else {
        Logger.debug('Connectivity is offline');
      }
    },
    surveyInProgress: function surveyInProgress(newId, oldId) {
      var _this2 = this;

      if (oldId) {
        Logger.debug("Survey id ".concat(oldId, " is no longer in progress"));
        this.pollServer();
      }

      if (newId) {
        Logger.debug("Survey id ".concat(newId, " is now in progress"));
        setTimeout(function () {
          var _this2$companyDetails, _this2$currentSurvey, _this2$currentSurvey2, _this2$$store$getters;

          surveyStarted({
            companyName: ((_this2$companyDetails = _this2.companyDetails) === null || _this2$companyDetails === void 0 ? void 0 : _this2$companyDetails.name) || '',
            surveyId: ((_this2$currentSurvey = _this2.currentSurvey) === null || _this2$currentSurvey === void 0 ? void 0 : _this2$currentSurvey.surveyId) || null,
            surveyTypeId: ((_this2$currentSurvey2 = _this2.currentSurvey) === null || _this2$currentSurvey2 === void 0 ? void 0 : _this2$currentSurvey2.surveyTypeId) || null,
            isPveUser: !!((_this2$$store$getters = _this2.$store.getters['checkIn/urlParams']) !== null && _this2$$store$getters !== void 0 && _this2$$store$getters.pve)
          });
        });
      }
    },
    cookieConsent: {
      immediate: true,
      handler: function handler(consented) {
        enableAnalytics(consented);
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.$store.dispatch('cookies/loadConsent');

    if ((navigator || {}).serviceWorker) {
      // Listen for download app settings periodic sync event
      navigator.serviceWorker.addEventListener('message', function (event) {
        if (_this3.registered && event.data === 'download-app-settings') {
          _this3.fetchConfig();
        }
      });
    }

    document.addEventListener('swUpdated', this.showRefreshUI, {
      once: true
    });

    if (sessionStorage.getItem('updatingApp') === 'true') {
      this.$store.commit('app/SET_UPDATE_COMPLETE', true);
      sessionStorage.setItem('updatingApp', false);
    }

    this.setup = new setupClass(); // Set the frequency with which we'll check if it's time to sync

    if (this.isApp) {
      if (POLLING_FREQUENCY) {
        setInterval(function () {
          _this3.updateWhenOnline = !_this3.hasConnectivity;

          _this3.pollServer();
        }, POLLING_FREQUENCY);
      } // Generate UUID to identify the device


      Logger.debug('Generating fingerprint');
      setTimeout(function () {
        if (!_this3.uuid) {
          var fpPromise = FingerprintJS.load();
          fpPromise.then(function (fp) {
            return fp.get();
          }).then(function (result) {
            return _this3.uuid = result.visitorId;
          }); // Save UUID to store
        }
      }, 500);
    } // reset errors module


    this.$store.commit('errors/resetState'); ////////////////////////////////////////////////////////////////////////////////////////////////
    //    ____              __    __   _     __
    //   / __/  _____ ___  / /_  / /  (_)__ / /____ ___  ___ _______
    //  / _/| |/ / -_) _ \/ __/ / /__/ (_-</ __/ -_) _ \/ -_) __(_-<
    // /___/|___/\__/_//_/\__/ /____/_/___/\__/\__/_//_/\__/_/ /___/
    // Listen for requests to poll the server (e.g. from `Connectivity.vue` component)

    this.$root.$on('poll-server', function () {
      Logger.debug('Received a request to poll the server');

      _this3.pollServer();
    }); // Listen for specific (SPA related) events if we're NOT running in PWA mode

    if (process.env.MODE !== 'pwa' || process.env.APP_FOR_WEB) {
      // Set initial connectivity state
      this.hasConnectivity = navigator.onLine; // Listen for connectivity changing to an offline state

      window.addEventListener('offline', function () {
        _this3.hasConnectivity = false;
      }); // Listen for connectivity changing to an online state

      window.addEventListener('online', function () {
        _this3.hasConnectivity = true;
      });
    }
  },
  mounted: function mounted() {
    this.updateTheme();
    this.$store.commit('app/SET_APP_REFRESHING', false);
    window.addEventListener('beforeunload', this.onUnload());
  },
  methods: {
    showRefreshUI: function showRefreshUI(e) {
      this.$store.commit('app/SET_APP_UPDATE_READY', true);
      this.$store.commit('app/SET_APP_REGISTRATION', e.detail);
    },
    fetchConfig: call('config/fetchConfig'),
    fetchSurveys: call('surveys/fetchSurveys'),
    moveConfig: call('config/moveData'),
    moveSurveys: call('surveys/moveData'),
    sendResponses: call('responses/sendResponses'),
    updateTheme: call('theme/updateTheme'),
    pollServer: function pollServer() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this4.pollInProgress) {
                  _context2.next = 3;
                  break;
                }

                Logger.debug('Server poll already in progress');
                return _context2.abrupt("return");

              case 3:
                if (_this4.setupComplete) {
                  _context2.next = 6;
                  break;
                }

                Logger.debug('Cannot poll until device registration has been completed');
                return _context2.abrupt("return");

              case 6:
                if (_this4.hasConnectivity) {
                  _context2.next = 10;
                  break;
                }

                Logger.warn('Cannot poll the server while offline, will retry when online');
                _this4.updateWhenOnline = true;
                return _context2.abrupt("return");

              case 10:
                // Move config and question/survey data (if any) out of temporary storage
                Logger.debug('Check for data in temporary storage');

                _this4.moveConfig();

                _this4.moveSurveys();

                _context2.prev = 13;

                // Set the first sync time if necessary
                if (!_this4.nextSync) {
                  _this4.setNextSync();
                } // Time to sync?


                if (!(moment().unix() >= _this4.nextSync)) {
                  _context2.next = 26;
                  break;
                }

                // Set the next sync time
                _this4.setNextSync(); // Poll the server


                Logger.debug('Poll server');
                _this4.pollInProgress = true;
                Logger.debug('Check for config updates');
                _context2.next = 22;
                return _this4.fetchConfig();

              case 22:
                Logger.debug('Check for survey updates');
                _context2.next = 25;
                return _this4.fetchSurveys();

              case 25:
                // this.updateLang(); //! function doesnt do anything
                _this4.pollInProgress = false;

              case 26:
                _context2.next = 31;
                break;

              case 28:
                _context2.prev = 28;
                _context2.t0 = _context2["catch"](13);
                Logger.error(_context2.t0.message);

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[13, 28]]);
      }))();
    },
    setNextSync: function setNextSync() {
      var variance = Math.round(Math.random() * this.syncSchedule.spread);
      this.nextSync = parser.parseExpression(this.syncSchedule.when).next()._date.unix() + variance;
    },
    onCookieConsentSelected: function onCookieConsentSelected(consented) {
      this.$store.dispatch('cookies/setConsent', consented);
    },
    onUnload: function onUnload() {
      var _this$companyDetails, _this$currentSurvey, _this$currentSurvey2, _this$$store$getters$;

      // testing the before unload event.
      surveyLeft({
        companyName: ((_this$companyDetails = this.companyDetails) === null || _this$companyDetails === void 0 ? void 0 : _this$companyDetails.name) || '',
        surveyId: ((_this$currentSurvey = this.currentSurvey) === null || _this$currentSurvey === void 0 ? void 0 : _this$currentSurvey.surveyId) || null,
        surveyTypeId: ((_this$currentSurvey2 = this.currentSurvey) === null || _this$currentSurvey2 === void 0 ? void 0 : _this$currentSurvey2.surveyTypeId) || null,
        branchId: this.branchId || null,
        isPveUser: !!((_this$$store$getters$ = this.$store.getters['checkIn/urlParams']) !== null && _this$$store$getters$ !== void 0 && _this$$store$getters$.pve)
      });
    } // updateLang() { //! not returning/doing anything
    //   // this is an imperfect solution as it would be prefereble to centralise this, but access
    //   // to i18n is currently limited - if someone can implement a solution in the future where
    //   // all lang is stored in state (not i18n) and this function can be called from there,
    //   // that would be preferable to having this called in multiple components
    //   const localLang = cloneDeep(this.$root.$i18n.getLocaleMessage(this.$root.$i18n.locale));
    //   // serverLang may need a function to treat/map it first (this would be fetched from config,
    //   // below is just an example)
    //   const serverLang = { manageTeam: { add: 'some altered string' } }; // changes 'add' button text on manageTeam screen which is easy to see
    //   const mergedLang = merge(localLang, serverLang);
    //   // this.$root.$i18n.setLocaleMessage(this.$root.$i18n.locale, mergedLang) // uncomment to see in action
    // }

  }
};